export default "__VITE_ASSET__5xj6HeT4__"